import { Flex } from "antd";
import Button from "components/commons/Button";
import { useDispatch } from "react-redux";
import { ChangeEvent, useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { regexEmail } from "utils/regex";
import EmailIcon from "assets/lock.svg";
import PasswordIcon from "assets/mail.svg";
import { signin, RoleType, TSignin } from "services/login";
import { Path } from "routers/path";
import styled from "styled-components";
import Input from "components/commons/Input";
import {
  setAccessToken,
  setRefreshToken,
  setRole,
} from "features/authUserSlice";
import {
  setAccessTokenLocalStorage,
  setRefreshTokenLocalStorage,
} from "utils/token";
import ImageLogo from "assets/logo.png";

const init = {
  emailOrPhone: "",
  password: "",
};

const SignIn = () => {
  const dispatch = useDispatch();
  const naviagte = useNavigate();
  const [data, setData] = useState<TSignin>(init);
  const [errors, setErrors] = useState<TSignin>(init);

  const isDisable = useMemo(() => {
    return (
      Object.keys(data).some((item) => !data[item as keyof TSignin]) ||
      Object.keys(errors).some((item) => errors[item as keyof TSignin])
    );
  }, [data, errors]);

  const handleSubmit = useCallback(async () => {
    try {
      const { data: d } = await signin(data);

      if (d.role !== RoleType.ADMIN) {
        return setErrors({
          emailOrPhone: "You are not admin!",
          password: "",
        });
      }
      const { accessToken, refreshToken, role } = d;
      setAccessTokenLocalStorage(accessToken);
      setRefreshTokenLocalStorage(refreshToken);
      dispatch(setAccessToken({ accessToken }));
      dispatch(setRefreshToken({ refreshToken }));
      dispatch(setRole({ role }));
      naviagte(Path.HOMEPAGE);
    } catch (error: any) {
      if (
        error.status === 400 &&
        error.response?.data?.message === "PASSWORD_WRONG"
      )
        setErrors((pre) => ({ ...pre, password: "wrong password!" }));
      if (
        error.status === 400 &&
        error.response?.data?.message === "USER_NOT_FOUND"
      )
        setErrors((pre) => ({ ...pre, emailOrPhone: "user not found!" }));
    }
  }, [data, dispatch, naviagte]);

  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setData((pre) => ({ ...pre, [name]: value }));
    if (!value)
      return setErrors((pre) => ({
        ...pre,
        [name]: `${name === "password" ? name : "email"} is required`,
      }));
    if (name === "emailOrPhone") {
      return setErrors((pre) => ({
        ...pre,
        [name]: !regexEmail.test(value) ? "Invalid email address!" : "",
      }));
    }
    setErrors(init);
  }, []);

  return (
    <SignInWrapper vertical={true} className="sign-in-wrapper">
      <img
        src={ImageLogo}
        alt="logo"
        width={"100%"}
        height={"120px"}
        style={{ objectFit: "contain" }}
      />
      <FormWrapper className="form-wrapper" vertical={true}>
        <Input
          title="Email Address"
          name="emailOrPhone"
          prefix={<img src={EmailIcon} alt="" />}
          errors={errors.emailOrPhone}
          onChange={handleChange}
          value={data.emailOrPhone}
        />
        <Input
          title="Password"
          name="password"
          prefix={<img src={PasswordIcon} alt="" />}
          errors={errors.password}
          onChange={handleChange}
          value={data.password}
          type="password"
        />
        <Flex className="group-button" justify="end">
          <Button height="60px" onClick={handleSubmit} disabled={isDisable}>
            Sign in
          </Button>
        </Flex>
      </FormWrapper>
    </SignInWrapper>
  );
};

export default SignIn;

const SignInWrapper = styled(Flex)`
  width: 512px;
  margin: auto;
  align-items: center;
  height: 100vh;
  background-color: #ffffff;
  justify-content: center;
`;

const FormWrapper = styled(Flex)`
  width: 80%;
  gap: 30px;
  font-size: 20px;
`;
